import Flickity from 'flickity'

var utils = require('fizzy-ui-utils');

var carousel = document.querySelector('.en-savoir-plus-carousel');

if (carousel) {
  var flkty = new Flickity(carousel, {
    cellAlign: 'left',
    cellSelector: '.carousel-cell',
    resize: true,
    prevNextButtons: false,
    pageDots: false,
    groupCells: 2
  });

// previous
  var previousButton = document.querySelector('.button--previous');
  previousButton.addEventListener('click', function () {
    flkty.previous();
  });

// next
  var nextButton = document.querySelector('.button--next');
  nextButton.addEventListener('click', function () {
    flkty.next();
  });

  window.addEventListener( 'load', function() {
    flkty.resize();
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/includes/en-savoir-plus.js